import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ProtectedRoute } from '../ProtectedRoute';

const StaffOverviewDataGrid = loadable(
  () => import('@/pages/AdminHub/StaffOverview/StaffOverviewDataGrid')
); // prettier-ignore
const StaffOverviewPage = loadable(
  () => import('@/pages/AdminHub/StaffOverview')
); // prettier-ignore

export enum AdminHubStaffOverviewRoutes {
  AdminHubStaffOverview = '/:domain/admin-hub/staff-overview'
}

export const getAdminHubStaffOverviewRoutes = (): RouteObject[] => {
  return [
    {
      path: AdminHubStaffOverviewRoutes.AdminHubStaffOverview,
      element: <ProtectedRoute component={StaffOverviewPage} role="L1" />,
      children: [
        {
          path: '', // This makes it render at the parent route path
          element: <StaffOverviewDataGrid />
        }
      ]
    }
  ];
};
